export default __webpack_public_path__ + "assets/c1343703acaacde62fe542629e5cf15e.png";